/**
 * В .env часто указывают host:port без схемы (localhost:5000).
 * В браузере fetch('localhost:5000/api/...') превращается в путь на текущем origin → Session failed.
 */
export function normalizeApiBase(raw) {
  const u = (raw != null ? String(raw) : '').trim();
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u.replace(/\/+$/, '');
  return `http://${u.replace(/^\/+/, '')}`.replace(/\/+$/, '');
}

function resolveApiBase() {
  let base = normalizeApiBase(process.env.REACT_APP_API_URL);
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname.toLowerCase();
    if (host === 'zoo-taxi.com' || host.endsWith('.zoo-taxi.com')) {
      return window.location.origin;
    }
    const isLocalPage = host === 'localhost' || host === '127.0.0.1';
    const baseIsLocal = !base || /localhost|127\.0\.0\.1/.test(base);
    if (!isLocalPage && baseIsLocal) {
      return window.location.origin;
    }
    if (!base) {
      return window.location.origin;
    }
  }
  if (!base) return 'http://localhost:5000';
  return base;
}

export const API_URL = resolveApiBase();
export const LOCAL_FALLBACK_API_URL =
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : 'http://localhost:5000';
